<template>
    <div>
        <div class="flex flex-wrap" v-if="view == 'grid'">
            <div class="w-full">
                <div class="flex flex-col">
                    <div class="flex shadow-md">
                        <div class="relative w-2/5">
                            <img class="w-full h-full rounded-tl shadow-md" :src="project.image">
                        </div>
                        <div class="flex flex-col flex-1 bg-gray-100 px-6 pt-2 text-sm" v-bind:class="{'bg-red-light text-red-lightest': project.is_upcoming}">
                            <div class="flex items-center py-4">
                        		<div class="text-2xl uppercase">{{ project.name }}</div>
                                <div class="text-base px-2">/</div>
                                <div class="text-xl">Proposals</div>
                            </div>

        					<div>
					            <table class="w-full">
					                <thead class="cursor-pointer">
					                    <th class="pl-4">Address</th>
					                    <th class="text-center">Rev #</th>
					                    <th class="text-right">Year 1 $ (PSF)</th>
					                    <th class="text-center">Date</th>
					                    <th></th>
					                </thead>
					                <tbody>
					                    <tr v-for="(proposal, proposalIndex) in project.proposals" :key="proposalIndex">
					                        <td class="pl-4 leading-normal">
                              					<p class="text-lg font-semibold">{{ proposal.building.address_line_1 }}</p>
                                				<p class="text-base">{{ proposal.building.city }}, {{ proposal.building.state }}  {{ proposal.building.postal_code | truncate(5) }}</p>
					                        </td>
					                        <td class="text-center">{{ proposal.revision_number }}</td>
					                        <td class="text-right pr-3">{{ formatCurrency(1500, 2) }} </td>
					                        <td class="text-center">{{ proposal.created_at | date }}</td>
					                        <td class="text-center">
				                                <a :href="proposal.view_url" title="Open Proposal">
				                                    <inline-svg name="show"></inline-svg>
				                                </a>
					                        </td>
					                    </tr>
					                </tbody>
					            </table>
                            </div>
                        </div>
                    </div>
		        	<div class="mx-6 mt-6">
		        		<comp-table :project-id="project.id" :comp-data="project.comps" :per-page="5"></comp-table>
		        	</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>   

    export default {
        props: {
            data: {
              type: [Array, Object],
              required: true
            },

            showHeader: {
              type: Boolean,
              default: true
            },

            smallHeader: {
              type: Boolean,
              default: false
            },

            showFilters: {
              type: Boolean,
              default: true
            }, 

            view: {
                type: String,
                default: 'grid'
            }
        },

        data() {
        	return {
        		layout: this.view
        	}
        },

        computed: {
            project() {
                return this.data;
            },

			proposalsBadge() {
				return "<span class='text-xs text-white bg-teal-600 rounded-full p-1 px-2 font-semibold ml-2'>" + this.project.proposals.length + "</span>";
			},

	   		compsBadge() {
				return "<span class='text-xs text-white bg-green-600 rounded-full p-1 px-2 font-semibold ml-2'>" + this.project.comps.length + "</span>";
			},
		},

        methods: {
            
        }
    }
</script>